{
  "areYouSureClose": "Er du sikker på at du vil lukke",
  "backToOpportunities": "Tilbake til henvendelsar",
  "button.Forward": "Send vidare",
  "button.RecommendService": "Anbefal teneste",
  "button.RegisterService": "Registrer teneste",
  "actionbar.StartEmailThread": "Send ny epost",
  "actionbar.RecommendService": "Anbefal teneste",
  "actionbar.DeliverService": "Lever teneste",
  "actionbar.AddNote": "Lag notat",
  "actionbar.ProgramAdmission": "Ta opp",
  "actionbar.Refer": "Henvis vidare",
  "chooseForwardRecipient": "Velg kven som skal bli tilsendt denne henvendelsen",
  "chooseRecommendedServices": "Velg kva tjenester de ønsker å anbefale",
  "chooseRegisterServices": "Velg kva tjenester de ønsker å tilby",
  "closedOpportunitiesFoundInArchive": "Lukka henvendelsar finn du i arkivet",
  "details.Referral.Actor.TextAreaField.Required": "Melding til aktørar *",
  "documentTitleOpportunities": "Henvendelsar - Fleirbedriftsportalen",
  "documentTitleOpportunityDetails": "Henvendelse detaljar - Fleirbedriftsportalen",
  "doYouWantToAddOrganizationAsLead": "Vil du legge til denne organisasjonen som eit lead?",
  "doYouWantToResumeOpportunity": "Vil du gjenopne denne henvendelsen?",
  "errorCouldNotGetAllForms": "Kunne ikkje hente henvendelsar.",
  "errorCouldNotGetForm": "Kunne ikkje hente skjema.",
  "errorErrorBoundaryCouldNotShow": "Visning av henvendelse feila. Vennlegst ta kontakt med oss dersom dette skjer.",
  "getMoreOpportunities": "Hent fleire henvendelsar",
  "isUnderDevelopment": "er under utvikling",
  "missingOpportunityInfo": "Manglar informasjon om henvendelsen",
  "municipalityFirstLineFor": "Førstelinjeteneste for",
  "noHistoryFound": "Inga historie funne.",
  "noServicesAvailable": "Ingen tjenester tilgjengeleg.",
  "opportunities": "Henvendelsar",
  "opportunityDetails.And": "og",
  "opportunityDetails.Contract": "Avtale",
  "opportunityDetails.Phase": "Fase",
  "opportunityDetails.AdmissionDate": "Opptaksdato",
  "opportunityDetails.RegisteredDate": "Registreringsdato",
  "opportunityDetails.Advisor": "Rådgjevar",
  "opportunityDetails.ClosedService": "Lukka tjeneste.",
  "opportunityDetails.CreationError": "Kunne ikkje hente eller opprette henvendelse.",
  "opportunityDetails.ForwardedTo": "Vidaresendt til",
  "opportunityDetails.ReferredFrom": "Henvist frå",
  "opportunityDetails.ActorsWhoReferredToYou": "Aktørar som har henvist til deg",
  "opportunityDetails.FirstLineServiceFor": "Førstelinje for {{municipality}}",
  "opportunityDetails.FoundNoOpportunities": "Fann ingen henvendelsar",
  "opportunityDetails.MunicipalitiesList": "Alle henvendelsar frå:",
  "opportunityDetails.NoRegisteredMunicipalities": "Ingen registrerte kommuner.",
  "opportunityDetails.OtherServices": "andre tjenester",
  "opportunityDetails.RecommendedServices": "Anbefalte tjenester",
  "opportunityDetails.RegisteredServices": "Registrerte tjenester",
  "opportunityDetails.ResumedService": "Gjenåpna tjeneste.",
  "opportunityDetails.AccessTo": "Disse har tilgang til henvendelsen:",
  "opportunityDetails.CompanyMissing": "Bedrift manglar",
  "opportunityDetails.NameMissing": "Namn manglar",
  "opportunityDetails.MunicipalityMissing": "Kommune manglar",
  "opportunityDetails.PhoneMissing": "Telefonnummer manglar",
  "opportunityDetails.EmailMissing": "E-post manglar",
  "opportunityDetails.Concept": "Konseptet",
  "opportunityDetails.WhatCustomerNeedsHelpWith": "Kva kunden treng hjelp med",
  "opportunityDetails.ShowInCustomerRegister": "Vis i kunderegisteret",
  "opportunityDetails.OtherOpportunitiesFrom": "Andre henvendelsar frå {{name}}",
  "opportunityDetails.NoOtherOpportunities": "{{name}} har ingen andre registrerte henvendelsar",
  "opportunityDetails.ActorsWithAccess": "Aktørar med tilgang til henvendelsen",
  "organizationAlreadyExists": "Organisasjonen fins allereie i ressursbasen.",
  "retrievingFromBrreg": "Henter frå BrReg...",
  "referToast.Error": "Kunne ikkje sende tilvising. Prøv igjen og kontakt oss viss det held fram.",
  "referToast.Error409": "Kan ikkje sende tilvising fordi aktøren allereie har henvendinga hos seg.",
  "referToast.Pending": "Sender tilvising...",
  "referToast.Success": "Tilvising sendt!",
  "opportunitySearchInputPlaceHolder": "Søk etter henvendelse, navn eller kommune",
  "actorSearchInputPlaceHolder": "Søk etter aktørnavn, fylke eller kommune",
  "serviceSearchInputPlaceHolder": "Søk på tenestenavn, aktørnavn eller kontaktperson",
  "services.Displaying": "Viser",
  "services.OfTotal": "av totalt",
  "status.Active": "Aktiv",
  "status.Closed": "Lukka",
  "status.Forwarded": "Vidaresendt",
  "status.New": "Ny",
  "status.Opened": "Åpna",
  "status.Received": "Motteke",
  "status.ReOpened": "Gjenåpna",
  "status.FollowUpLater": "På vent",
  "status.AutoArchived": "Automatisk arkivert",
  "status.ReferredLater": "Ny henvising frå IN",
  "tabs.Interplay": "Samhandling",
  "tabs.Log": "Aktivitetslogg",
  "tabs.OneWayIn": "Henvendelse",
  "tabs.Services": "Tjenester",
  "tabs.actor": "Aktør",
  "tabs.greenPlatform": "Grøn plattform",
  "thisOpportunity": "denne henvendelsen",
  "updateToast.Error": "Feil ved oppdatering av henvendelse. Vennlegst prøv på nytt.",
  "updateToast.Pending": "Oppdaterar henvendelse...",
  "updateToast.Success": "Henvendelse oppdatert!",
  "reason": "Grunngjeving",
  "feedback.description": "Skriv inn kvifor henvendinga ikkje er sendt rett",
  "feedback.sentCorrectly": "Er denne henvendinga sendt riktig?",
  "feedback.sendWithoutSuggestion": "Send uten forslag",
  "opportunity.feedback.intro.1": "Før dykk snakker med kunden - gi oss et raskt svar",
  "opportunity.feedback.intro.2": "Var det riktig av Én vei inn å sende dere denne henvendinga?",
  "opportunity.feedback.intro.3": "Svaret dykkar gjer at dykk får flere riktige henvendigar. Det påvirker ikkje korleis dykk behandler henvendinga.",
  "opportunity.feedback.incorrect": "Fortell oss kvifor dykk ikke skal ha denne henvendinga",
  "opportunity.feedback.option.geography": "Feil geografisk nedslagsfelt",
  "opportunity.feedback.option.tooFar": "Selskapet/Gründeren har kommet for langt",
  "opportunity.feedback.option.tooShort": "Selskapet/Gründeren har ikke kommet langt nok",
  "opportunity.feedback.option.notEnoughInnovation": "For lav innovasjonsgrad",
  "opportunity.feedback.option.wrongBusiness": "Feil bransje",
  "opportunity.feedback.option.other": "Annet",
  "opportunity.feedback.confirmation": "Hjelp oss gjerne med å henvende til andre aktører om du har noen forslag.",
  "goToMunicipalityView": "Gå til kommunevisning",
  "goToCountyView": "Fylkesvisning",
  "noRegisteredCounties": "Ingen registrerte fylke",
  "log.table.column.activity": "Aktivitet",
  "log.table.column.actor": "Aktør",
  "log.table.column.behandler": "Behandlars namn",
  "log.table.column.description": "Beskrivelse",
  "services.recommended": "Anbefalte tjenester",
  "services.delivered": "Leverte tjenester",
  "tab.Form": "Skjema",
  "tab.INResponseMail": "Svar frå Innovasjon Noreg",
  "tabs.active": "Aktive henvendelsar",
  "tabs.archive": "Arkiv",
  "selectMunicipality": "Velg kommune",
  "selectStatus": "Velg status",
  "noOpportunitiesFoundTitle": "Ingen henvendelsar frå \"Én vei inn\"",
  "municipalityFirstLine": "Førstelinjetenesten",
  "addOpportunities.banner": "Du kan no legge til henvendelsar i Fleirbedriftsportalen. Klikk her for å generere ei lenke til En Vei Inn-skjemaet som du kan sende til kunden.",
  "addOpportunities.cta": "Lag ei lenke til En Vei Inn-skjemaet",
  "addOpportunities.header": "Be kunden om å fylle ut ein henvendelse",
  "addOpportunities.identifier.error": "Kundenavn må være på minst 3 tegn",
  "addOpportunities.date": "Dato for møte (valfritt)",
  "addOpportunities.error": "Noko gjekk gale når lenka blei laga. Vennlegst prøv igjen seinare.",
  "opportunity.correctlyReferred": "Var det riktig av Én vei inn å sende dykk denne henvendinga?",
  "opportunity.feedback.doYouWantToGoToReferral": "Vil du gå til henvising?",
  "opportunity.feedback.comment": "Fortell oss gjerne kvifor det er riktig å henvise til denne/disse aktørene",
  "opportunity.feedback.wrongComment": "Fortell oss gjerne kvifor det er feil å henvise denne til deg",
  "opportunity.feedback.goToReferral": "Gå til henvisning",
  "opportunity.feedback.selectedActors": "Du har valgt: ",
  "addOpportunities.main": "Her kan du lage ei lenke du kan dele med kunden. Lenka peiker til skjemaet for En Vei Inn-henvendingar. Kunden loggar seg inn med BankID og sender inn skjemaet. Innan ca. 2 verkedagar får kunden eit svar fra Innovasjon Norge, og henvendinga blir henvist til deg.",
  "addOpportunities.seeMore.1": "Hensikt",
  "addOpportunities.seeMore.2": "Vi utforsker moglegheiter til å få samla fleire henvendingar de får i Flerbedriftsportalen. I første omgang ønsker vi å bruke En Vei Inn-skjemaet til dette.",
  "addOpportunities.seeMore.3": "Framtida sin prosess",
  "addOpportunities.seeMore.4": "Vi held på med eit konsept som gjer at henvendingane havnar rett til dykk, umiddelbart. Ein e-post kan bli sendt til kunden for å fylle ut skjemaet. Vi vil teste ut slike løysingar etter kvart som vi får innsikt og tilbakemeldinger fra dykk.",
  "addOpportunities.referBack": "Ønsker du at kunden skal bli henvist <strong>tilbake til deg</strong> etter innsending av En Vei Inn-skjemaet?",
  "addOpportunities.submit": "Lag lenke",
  "opportunity.update.error": "Klarte ikkje å oppdatere henvendinga",
  "status.setFollowUpLater": "Sett på vent",
  "status.setFollowUpLater.title": "Sett henvendinga på vent",
  "status.setFollowUpLater.more": "Du kan følge opp henvendinga seinare. Skriv eit notat til seinare oppfølging. Notatet visast i Aktivitetslogg.",
  "status.setActive": "Sett i arbeid",
  "status.setActive.title": "Start behandlinga av henvendinga igjen",
  "status.setActive.more": "Behandlingen av henvendinga takast opp igjen. Skriv eit notat med begrunnelsen. Notatet vises i Aktivitetslogg.",
  "status.updateSuccess": "Status er oppdatert.",
  "opportunity.changeStatus": "Endre status:",
  "opportunity.feedback.alsoReferredTo": "Denne henvisinga er også sendt til: ",
  "opportunity.feedback.correct.title": "Så bra! Burde Innovasjon Norge også henvist til fleire?",
  "opportunity.feedback.correct.text": "Her kan du velge kva andre aktørar vi også burde henvist til. Del også gjerne tankar om henvisinga. Vi har ikkje muligheit til å svare på tilbakemeldinga di, men brukar den til å forbedre oss.",
  "opportunity.feedback.answerSent": "Svar sendt",
  "opportunity.feedback.incorrect.step1.title": "Kan du fortelle oss kvifor denne henvendinga er henvist feil til deg?",
  "opportunity.feedback.incorrect.step1.text": "Vi ønsker gjerne å vite kvifor det er feil å henvise denne til deg. Vi har ikkje mulighet til å svare på tilbakemeldinga di, men vi brukar den til å forbedre oss.",
  "opportunity.feedback.incorrect.step1.buttonText": "Neste: Henvis til andre aktørar",
  "opportunity.feedback.incorrect.step2.title": "Har du forslag til andre aktørar vi burde henvist til?",
  "opportunity.feedback.incorrect.step2.text": "Dersom du meiner vi burde henvist til andre, send gjerne ei henvising til aktuelle aktørar vi burde henvist til. Hvis du ikkje har nokon forslag kan du arkivere henvendinga.",
  "opportunity.feedback.incorrect.step2.button1Text": "Gå til henvising",
  "opportunity.feedback.incorrect.step2.button2Text": "Arkiver",
  "opportunity.feedback.thankYou": "Takk for tilbakemeldinga!",
  "opportunity.feedback.forwardToAnotherActor": "Henvis gjerne denne henvendinga vidare til ein annan aktør",
  "opportunity.table.filter.noMunicipality": "Utan kommune",
  "opportunity.addAdvisor.toastSuccess.title": "Rådgjevar tilordna",
  "opportunity.addAdvisor.toastSuccess.info": "Namnet til tilordna rådgjevar vil visast",
  "opportunity.addAdvisor.email.toastSuccess.title": "E-postvarsel er sendt",
  "opportunity.addAdvisor.email.toastSuccess.info": "Tilordna rådgjevar får eit e-postvarsel",
  "opportunity.addAdvisor.toastError.title": "Kunne ikkje tilordne rådgjevar",
  "opportunity.addAdvisor.toastError.info": "Prøv igjen. Dersom problemet vedvarar, kontakt oss på support@enveiinn.no",
  "opportunity.addAdvisor.modal.title": "Tilordne rådgjevar",
  "opportunity.addAdvisor.modal.infoText": "Du kan tilordne henvendinga til ein rådgjevar i din organisasjon. Namnet til rådgjevaren vil visast i henvendingsoversikta. Dersom du ikkje finn rådgjevaren kan du invitere vedkommende til Flerbedriftsportalen.",
  "opportunity.addAdvisor.modal.invite": "Inviter ein ny bruker via ",
  "opportunity.addAdvisor.modal.searchPlaceholder": "Søk etter rådgjevar",
  "opportunity.addAdvisor.addButton": "Tilordne til rådgjevar",
  "opportunity.addAdvisor.notAssigned": "Ikkje tilordna",
  "opportunity.addAdvisor.sendEmail": "Send e-postvarsel til rådgjevaren",
  "advisor.label": "Rådgjevar:",
  "advisor.tooltip": "Rådgjevar",
  "advisor.currentlyAssigned": "Tilordna rådgjevar",
  "advisor.changeAdvisor": "Bytt rådgjevar",
  "advisor.assignAdvisor": "Tilordne rådgjevar",
  "opportunity.addAdvisor.dialog.sendEmailQuestion": "Ønsker du å sende e-postvarsel til {{advisorName}}?",
  "opportunity.addAdvisor.dialog.advisorFallback": "rådgjevaren",
  "opportunity.activeWithDeliveredServices": "Aktive henvendelsar med leverte tjenester",

  "services.edit.unpublished": "Tjenesta er avpublisert",
  "services.edit.draftDeleted": "Utkastet er sletta",
  "services.edit.serviceDeleted": "Tjenesta er sletta",
  "services.edit.edit": "Rediger tjeneste",
  "services.edit.unpublish": "Avpubliser tjeneste",
  "services.edit.delete": "Slett tjeneste",
  "services.edit.deleteDraft": "Slett utkast",
  "services.edit.editOrPublish": "Rediger og/eller publiser tjeneste",
  "services.edit.unpublishWarning": "Tjenesta vil bli satt til utkast. Du kan publisere den igjen seinare.",
  "services.edit.deleteWarning": "Tjenesta vil bli sletta for godt.",
  "services.edit.deleteDraftWarning": "Utkastet vil bli sletta for godt.",
  "services.recommend.success": "Teneste anbefalt",
  "services.recommend.error": "Kunne ikkje anbefale teneste.",

  "referral.notification.step1.error.noneSelected": "Du må velja éin aktør å tilvise til",
  "referral.notification.step2.error.noActorMessage": "Melding til aktør må fylles ut.",
  "referral.notification.step2.error.noCustomerMessage": "Melding til kunde må fylles ut.",
  "referral.notification.step3.error": "Vi kunne ikkje sende tilvisninga. Prøv igjen og viss problemet held fram kontakt oss på ",
  "referral.notification.step3.error.receiverAlreadyHasCustomer": "Tilvisninga vart ikkje sendt sidan mottakaren allereie har kunden inne. Viss du likevel vil tilvise til dei, kan du leggje til tenester i tilvisninga.",
  "details.Referral.Table.RowSelectedText_zero": "Du må velja ein aktør for å tilvise henvendinga vidare",
  "details.Referral.Table.RowSelectedText_one": "{{count}} aktør er valt",
  "details.Referral.Table.RowSelectedText_other": "{{count}} aktørar er valde",
  "details.Title.ActivityLog": "Aktivitetslogg",
  "details.Title.Archiving": "Arkiver",
  "details.Title.Inquiry": "Henvending",
  "details.Title.Referrer": "Henvis videre",
  "details.Title.Services": "Tenester",
  "details.Title.CustomerCommunication": "Kommunikasjon",
  "details.Title.CompanyInfo": "Bedriftsinfo",
  "companyInfo.viewInCustomerRegistry": "Vis i kunderegisteret",
  "details.Title.CustomerFollowUp": "Kundeoppfølging",
  "referral.navigationBar.step3.primaryButtonText": "Fullfør og send tilvisning",
  "frontpage.notification.newOpportunities": "{{opportunityNumber}} ulesne henvendelsar",
  "frontpage.notification.newOpportunity": "1 ulest henvending",
  "frontpage.notification.opportunities": "{{opportunityNumber}} henvendelsar",
  "frontpage.notification.opportunity": "1 henvending",
  "frontpage.actors": "Aktører i",
  "frontpage.actorTotal": "{{count}} aktører er registrert i flerbedriftsportalen per",
  "frontpage.howTo.header": "Slik behandler du Én vei inn-henvendelser",
  "frontpage.howTo.evaluateReferral.header": "Vurder om henvisningen er riktig",
  "frontpage.howTo.evaluateReferral.text": "Les henvendelsen og gi tilbakemelding på om den er henvist riktig til deg.",
  "frontpage.howTo.referral.header": "Henvis til andre aktører",
  "frontpage.howTo.referral.text": "Henvis til andre aktører hvis henvendelsen også er relevant for dem. Anbefal gjerne kunden tjenester som du mener passer for kunden.",
  "frontpage.howTo.services.header": "Synliggjør dine tjenester",
  "frontpage.howTo.services.text": "Legg til dine egne tjenester. Anbefal tjenester til kunden. Marker hvilke du har levert. Dette gjør dine tjenester mer synlig for andre aktører.",
  "frontpage.howTo.memory.header": "Bygg felles hukommelse",
  "frontpage.howTo.memory.text": "Oppdater henvendelsen med hvordan du har hjulpet kunden, slik at alle i virkemiddelapparatet kan bistå kunden på best mulig måte.",
  "frontpage.countyServices.none": "Ingen tjenester har blitt registrert i ditt fylke",
  "frontpage.statistics.recommended.total": "Totalt antall anbefalte tenester",

  "customerFollowUp.myServices": "Mine tenester ({{count}})",
  "customerFollowUp.goToMyServices": "Gå til Mine tenester",
  "customerFollowup.cantFindService": "Finn du ikkje tenesta? Registrer den i Felles tenestekatalog.",
  "customerFollowup.recommended": "Anbefalt",
  "customerFollowup.notRecommended": "Ikkje anbefalt",
  "customerFollowUp.deliverService": "Lever teneste",

  "customerFollowUp.toast.error.title": "Det har oppstått ein feil",
  "customerFollowUp.toast.error.text": "Prøv på nytt seinare. Dersom feilen halde fram, kontakt oss.",

  "customerFollowUp.addNote.toast.success.title": "Notat er lagt til",
  "customerFollowUp.addNote.toast.success.text": "Du finn notatet i aktivitetslogg.",
  "customerFollowUp.addNote.toast.error.title": "Det har oppstått ein feil",
  "customerFollowUp.addNote.toast.error.text": "Prøv på nytt seinare. Dersom feilen held fram, kontakt oss.",
  "customerFollowUp.addNote.title": "Lag notat",
  "customerFollowUp.addNote.p1": "Her kan du leggja til informasjon som er nyttig for deg sjølv og andre som jobbar med denne henvendinga. Notatet kan innehalde:",
  "customerFollowUp.addNote.li1": "Kommunikasjon med kunde som f.eks. møte, e-post eller telefonsamtalar.",
  "customerFollowUp.addNote.li2": "Anbefalingar eller viktige avklaringar med kunden.",
  "customerFollowUp.addNote.li3": "Forslag til neste steg for kunden.",
  "customerFollowUp.addNote.p2": "Notatet lagres i aktivitetsloggen og bidrar til felles hukommelse og effektiv oppfølging. Ver tydeleg og konkret.",

  "customerFollowUp.deliveredServices.title": "Leverte tenester",
  "customerFollowUp.deliveredServices.p1": "Her vel du kva tenester du har gitt kunden som ein del av behandlinga av henvendinga. Desse blir då lagt til i aktivitetsloggen.",
  "customerFollowUp.deliveredServices.servicesDelivered": "Teneste levert",
  "customerFollowUp.deliveredServices.delivered": "Levert",
  "customerFollowUp.notDelivered": "Ikkje levert",
  "customerFollowUp.deliveredServices.modal.title": "Bekreft at du har levert tenesten",
  "customerFollowUp.deliveredServices.modal.p1": "Kva er neste skritt for kunden?",
  "customerFollowUp.deliveredServices.modal.p2": "All informasjon blir lagt til i aktivitetsloggen og hjelper andre aktørar som skal jobbe med denne henvendinga.",
  "customerFollowUp.deliveredServices.modal.p3": "Viss ein annan aktør kunne ha hjelpt kunden, hugs å tilvis vidare.",
  "customerFollowUp.deliveredServices.confirmDelivered": "Bekreft levert",
  "customerFollowUp.deliveredServices.toast.success.title": "Registrert levert teneste",
  "customerFollowUp.deliveredServices.toast.success.text": "Den vil bli lagt til i aktivitetslogg",

  "customerFollowUp.recommendServices.title": "Anbefal egne tenester via e-post",
  "customerFollowUp.recommendServices.p1": "Her kan du anbefale dine eigne tenester til kunden.",
  "customerFollowUp.recommendServices.toast.success.title": "Anbefaling sendt",
  "customerFollowUp.recommendServices.modal.p1": "Autogenerert e-post som sendes ut til kunden. Teksten du fyller ut i innskrivingsfeltet vil sendes på samme plass som den er plassert.",
  "customerFollowUp.recommendServices.modal.emailPreview.textArea.placeholder": "Fyll inn eventuell tilleggsinformasjon her",
  "customerFollowUp.recommendServices.modal.p2": "Informasjonen blir lagt til i aktivitetsloggen og hjelper andre aktører som skal jobbe med denne henvendinga.",
  "customerFollowUp.recommendServices.modal.button.primary": "Send anbefaling",
  "customerFollowUp.recommendServices.alert.title": "Nytt i Tenestekatalogen",
  "customerFollowUp.recommendServices.alert.text": "Tenester kan no innehalde ein kort tekst for å selje den inn til kundar. Rediger tenestene dine for å ta dette i bruk.",

  "customerFollowUp.recommendedServices.title": "Tenester andre aktørar har anbefalt hos deg",
  "customerFollowUp.recommendedServices.p1": "Desse tenestene har andre aktørar anbefalt hos deg. Trykk på “Lever teneste” viss du har levert tenesten til kunden.",

  "referring.chosenActorForReferral": "Henvisning til:",
  "referring.servicesIn": "Tjenester i",
  "referring.serviceDescription": "Beskriving av tenesta",
  "referring.deliveryTypes": "Korleis tenesta blir levert",
  "referring.companyAge": "Krav til føretakets alder",
  "companyAge.UnderThreeYears": "Under 3 år",
  "companyAge.OverFiveYears": "Over 5 år",
  "companyAge.UnderFiveYears": "Under 5 år",
  "companyAge.RelevantForAllAges": "Relevant for alle aldrar",
  "companyAge.Unknown": "Ukjend",
  "referring.companySize": "Krav til føretakets storleik",
  "companySize.Small": "Liten",
  "companySize.Small.Description": "<50 årsverk",
  "companySize.Medium": "Middels",
  "companySize.Medium.Description": "50-250 årsverk",
  "companySize.Large": "Stor",
  "companySize.Large.Description": ">250 årsverk",
  "companySize.OtherCategoriesMayApply": "Andre kategoriar kan gjelde",
  "companySize.Unknown": "Ukjend",
  "deliveryType.Connecting": "Kopling",
  "deliveryType.Egenkapital": "Eigenkapital",
  "deliveryType.Fellesarrangementer": "Fellesarrangement",
  "deliveryType.Foredrag": "Føredrag",
  "deliveryType.Garantier": "Garantiar",
  "deliveryType.Kurs": "Kurs",
  "deliveryType.Lavrisikolaan": "Lågrisikolån",
  "deliveryType.Orientering": "Orientering",
  "deliveryType.Prosjektarbeid": "Prosjektarbeid",
  "deliveryType.Publikasjon": "Publikasjon",
  "deliveryType.Raadgivning": "Rådgiving",
  "deliveryType.Risikolaan": "Risikolån",
  "deliveryType.Selvbetjening": "Sjølvbetening",
  "deliveryType.Tilskudd": "Tilskot",
  "deliveryType.Unknown": "Ukjent",
  "referring.servicesTable.selectedRowsSingular": "teneste valgt",
  "referring.servicesTable.selectedRowsPlural": "tenester valgt",
  "referring.servicesTable.showInfo": "Vis informasjon om tenesta",
  "referring.requirements": "Krav",
  "referring.selectedServices": "Tenester du foreslår for aktøren:",

  "referring.navigationBar.stepText.step0": "Vel aktøren du vil henvise til",
  "referring.navigationBar.stepText.step1": "Vel tenester som er relevante for kunden (valfritt)",
  "referring.navigationBar.stepText.step2": "Skriv melding til aktøren som mottar henvisninga",
  "referring.navigationBar.stepText.step3": "Send henvisninga",

  "referring.navigationBar.stepSubText.step2": "Du kan også sende epost til kunden",

  "connectCompany": "Tilknytt bedrift",
  "connectCompany.modal.description.part1": "Viss kunden har oppretta ei bedrift, kan du knytte henvendelsen til denne. Du må kjenne bedriftsnavnet for å gjøre det.",
  "connectCompany.modal.description.part2": "Når henvendelsen er tilknytt bedrifta, får du tilgang til bedriftsinformasjonen.",
  "connectCompany.toast.success.title": "Bedrift tilknyttet",
  "connectCompany.toast.error.title": "Kunne ikke tilknytte bedrifta",
  "connectCompany.toast.error.text": "Prøv igjen. Viss problemet held fram, kontakt oss på support@enveiinn.no.",

  "changeStatusDropdown.label": "Status:",
  "changeStatusDropdown.tooltip": "Status",
  "changeStatusDropdown.note": "Notat",
  "changeStatusDropdown.noteIsRequired": "Notatet må fyllast ut",
  "changeStatusDropdown.changingStatus": "Endrar status",
  "changeStatusDropdown.newStatus": "Ny status:",

  "changeStatusModal.changeStatus": "Endre status",
  "changeStatusModal.select.label": "Status",
  "changeStatusModal.select.placeholder": "Vel ny status",
  "changeStatusModal.toast.success.title": "Status endra",
  "changeStatusModal.toast.error.title": "Kunne ikkje endre statusen",
  "changeStatusModal.toast.error.text": "Prøv igjen. Viss problemet held fram, kontakt oss på support@enveiinn.no.",
  "changeStatusModal.mailReminder.checkbox.text": "Send meg ei påminning på mail",
  "changeStatusModal.mailReminder.dateInput.label": "Påminning skal sendes",
  "changeStatusModal.description.archive": "Sjølv om henvendelsen vil bli arkivert kan den gjenåpnes seinare ved behov.",
  "changeStatusModal.description.reOpen": "Behandlinga av henvendelsen gjenopptas. Skriv eit notat med grunngjevinga. Notatet vises i Aktivitetslogg.",
  "changeStatusModal.description.followUpLater": "Du kan følgje opp henvendelsen seinare. Skriv eit notat til seinare oppfølging. Notatet vises i Aktivitetslogg.",
  "changeStatusModal.currentStatus": "Nåverande status",
  "nationWide": "Landsdekkende",
  "communication.emailThreadFallback.p1": "Vi jobbar med å endre avsendaradressa for e-postane som blir sende frå Flerbedriftsportalen. Førebels er adressa",
  "communication.emailThreadFallback.p2": "Kundar kan ikkje sjå tidlegare meldingar i e-posten, men dei kan framleis svare direkte på e-posten du har sendt dei via Flerbedriftsportalen.",
  "communication.emailThreadFallback.p3": "Vi gjer løpande forbetringar i løysinga. Har du innspel eller spørsmål, høyrer vi gjerne frå deg.",
  "communication.emailThreadFallback.p4": "Takk for tolmodet!",
  "communication.newEmail.title": "Send ny e-post til kunde",
  "communication.newEmail.error.empty": "E-posten kan ikkje vere tom",
  "communication.newEmail.error.sendFailed": "Kan ikkje sende e-post. Prøv igjen seinare",
  "communication.newEmail.toast.title": "E-post sendt",
  "communication.newEmail.toast.text": "Du vil finne den i “Mi innboks”",

  "opportunityBoard.recommendServicesModal.title": "Anbefal egne tenester",
  "opportunityBoard.recommendServicesModal.description": "Legg til ein eller fleire tenester frå lista",
  "opportunityBoard.noServicesModal.title": "Du har ingen tenester",
  "opportunityBoard.noServicesModal.description": "For å bruke denne funksjonen må du opprette ein teneste.",
  "opportunityBoard.deliverServicesModal.title": "Lever egne tenester",
  "opportunityBoard.deliverServicesModal.description": "Vel ein eller fleire tenester frå lista",
  "opportunityBoard.deliverServicesModal.primaryButton": "Marker som levert",
  "opportunityBoard.deliverServicesModal.dateLabel": "Når blei tenesten(e) levert?",

  "errorMessage.NoServicesSelected": "Du må velje minst éin teneste.",
  "errorMessage.SomethingWentWrong": "Det har skjedd ein feil. Prøv igjen senere",
  "errorMessage.FieldEmpty": "Feltet kan ikkje vere tomt",

  "toasts.activityLogUpdated": "Aktivitetsloggen har blitt oppdatert",
  "toasts.serviceDelivery.success.title": "Tenestene er markert som levert",

  "tooltip.addAdvisor": "Legg til rådgjevar",
  "tooltip.changeAdvisor": "Endre rådgjevar",

  "providerType": "Aktørtype",
  "chooseProviderType": "Vel aktørtype",
  "chooseMunicipality": "Vel kommune",

  "noFiltersAvailable": "Ingen tilgjengelege filter",
  "filterByKeyword": "Filtrer med nøkkelord",

  "refer.dialog.ariaLabel": "Henvis moglegheita vidare",
  "refer.dialog.selectActor": "Vel aktøren du vil tilvise til",
  "refer.validation.noActorChosen": "Du må velja ein aktør for å kunne tilvise vidare",
  "refer.dialog.actorAlreadyHasOpportunity": "<bold>{{name}}</bold> har allereie henvendinga hos seg. Vel ein eller fleire tenester hos dei du vil anbefale.",
  "refer.dialog.chooseService": "Vel teneste hos <bold>{{name}}</bold> (valfritt)",
  "refer.validation.noServiceChosen": "Du må velja minst éi teneste",
  "refer.validation.messageEmpty": "E-posten kan ikkje vere tom",
  "refer.dialog.sendReferral": "Send tilvising",
  "refer.dialog.writeMessageToActor": "Send e-post til {{name}}",
  "refer.dialog.customerEmailPrompt.title": "Ønskjer du òg å sende e-post til kunden?",
  "refer.dialog.customerEmailPrompt.description": "Her kan du opplyse kunden om at henvendinga deira er sendt vidare",
  "refer.dialog.writeMessageToCustomer": "Send e-post til kunde",
  "refer.dialog.archivePrompt.title": "Ønskjer du å arkivere henvendinga?",
  "refer.dialog.archivePrompt.error": "Kunne ikkje arkivere. Prøv igjen seinare."
}
